module.exports = __webpack_public_path__ + "static/media/cht_1.f1909db1.jpg";